import { useState } from "preact/hooks";
import { t } from "../../i18n/index.ts";
import { Button } from "../../ui/Button.tsx";
import { Dialog, DialogActions } from "../../ui/Dialog.tsx";

/**
 * Beside an Office file's sort ("Excel spreadsheet"): Revisa's viewer or editor of it is in Beta, what is ("Excel
 * viewing is in Beta") its tooltip. Clicked, a dialog says what that means: it may not look exactly as in `app`.
 */
export function BetaBadge({ label, app }: { label: string /** What made it ("Microsoft Excel"). */; app: string }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        class="cursor-pointer rounded bg-violet-100 px-1.5 py-0.5 text-xs font-medium text-violet-800 hover:bg-violet-200"
        data-beta=""
        title={label}
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
      >
        {t("documents.beta")}
      </button>
      <Dialog open={open} onClose={() => setOpen(false)} title={label}>
        <p class="text-sm text-zinc-700">{t("documents.betaAbout", { app })}</p>
        <p class="text-sm text-zinc-700">{t("documents.betaOriginal")}</p>
        <DialogActions>
          <Button answer="confirm" variant="primary" onClick={() => setOpen(false)}>
            {t("documents.betaOk")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
